import { ParamsAdapter } from '@ng-gems/api';

import { User } from '@models/user.model';

export class UserSelfPreferencesPatchParams extends ParamsAdapter {
  constructor(protected user: User) {
    super();
  }

  getParams(): unknown {
    const siteGroups = this.user.siteGroups.map((it) => ({
      code: it.code,
      name: it.name,
      sites: it.sites.map((site) => ({ id: site.id })),
      accountId: it.accountId,
    }));

    return {
      user_preferences: JSON.stringify({
        siteGroups,
        lang: this.user.lang,
        hasSound: this.user.hasSound,
        onBoardDate: this.user.onBoardDate ? this.user.onBoardDate.toISOString() : null,
        preferredCountries: this.user.preferredCountries,
        preferredAccounts: this.user.selectedAccounts.map((account) => account.id),
        isTermsOfUseAccepted: this.user.isTermsOfUseAccepted,
        termsOfUseAcceptanceDate: this.user.termsOfUseAcceptanceDate,
      }),
    };
  }
}
